export enum CONVERSATION_TYPE {
  INBOX = 'inbox',
  OUTBOX = 'outbox',
  ARCHIVE = 'archive',
}
